module.exports = __webpack_public_path__ + "media/images/flags/4x3/and-828d9d8c62043a26a0e43533a543ac3e.svg";